import React from 'react'

function ContactStatus() {
  return (
    <div>ContactStatus</div>
  )
}

export default ContactStatus